document.addEventListener('click', function(event) {
  var nextButton = event.target.closest('[data-impressions-next]');
  var prevButton = event.target.closest('[data-impressions-prev]');

  if (!nextButton && !prevButton) return;

  var section = event.target.closest('.event-impressions__inner');

  if (!section) return;

  var track = section.querySelector('[data-impressions-track]');

  if (!track) return;

  var firstImage = track.querySelector('.event-impression');

  if (!firstImage) return;

  var trackStyles = window.getComputedStyle(track);
  var gap = parseFloat(trackStyles.gap) || 18;
  var distance = firstImage.offsetWidth + gap;

  track.scrollBy({
    left: nextButton ? distance : -distance,
    behavior: 'smooth'
  });
});


document.addEventListener('click', function(event) {
  var button = event.target.closest('[data-event-booking-scroll]');

  if (!button) return;

  var target = document.getElementById('event-buchung');

  if (!target) return;

  event.preventDefault();

  var top = 0;
  var element = target;

  while (element) {
    top += element.offsetTop;
    element = element.offsetParent;
  }

  var header = document.querySelector('.header-wrapper');
  var headerHeight = header ? header.offsetHeight : 0;

  window.scrollTo({
    top: top - headerHeight - 30,
    behavior: 'smooth'
  });
});